<div #overlayContainer
     (click)="closeNotification()"
     *ngIf="subscriptionService.overlayVisible$ | async"
     class="overlay-container">

    <div (click)="onContentClick($event)" class="inner">
        <div class="logo">
            <img alt="Loop Plus Logo" src="./assets/logos/loop-plus-text-white.svg"/>
        </div>

        <div class="headline"><ng-container i18n="subscription.note.start.now">Starte <span>jetzt!</span></ng-container> <i class="fa-thin fa-rocket-launch"></i></div>

        <p class="description">
            <ng-container i18n="subscription.note.intro.text1">Investiere jetzt in deinen Vorsprung: <strong>Mit Loop Plus Advance zu maximalem Erfolg!</strong></ng-container>
        </p>

        <!-- PACKAGE TABELLEN (DYNAMISCH) -->
        <div [ngClass]="type" class="packages">
            <!-- Standard Plan -->
            <div class="package standard">
                <div class="inner">
                    <div class="title">
                        {{ plans.standard.title }}
                        <span *ngIf="plans.standard.subtitle">{{ plans.standard.subtitle }}</span>
                    </div>

                    <div #standardContent class="content">
                        <ul>
                            <li (click)="showFeatureDetail(feature.id, 'standard')"
                                *ngFor="let feature of features"
                                [class.active]="selectedFeatureId === feature.id && currentPlan === 'standard'"
                                [class.none]="!isFeatureIncluded(feature.id, 'standard')"
                                [class]="feature.id">
                                <span>{{ feature.title }}</span>
                                <i class="fa-solid fa-circle-info"></i>
                            </li>
                        </ul>

                        <!-- Swiper für Feature-Details - wird eingeblendet wenn ein Feature ausgewählt ist -->
                        <div *ngIf="showStandardFeatureDetails" class="feature-details-overlay">
                            <div class="feature-details-container">
                                <!-- Swiper -->
                                <div #standardFactsSwiper class="swiper facts-swiper">
                                    <div class="swiper-wrapper">
                                        <div *ngFor="let feature of getIncludedFeatures('standard')" class="swiper-slide">
                                            <div class="feature-detail">
                                                <h3>{{ feature.title }}</h3>
                                                <p>{{ feature.description }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Buttons -->
                                <div class="buttons">
                                    <button (click)="manualPrev('standard')" class="prev"></button>
                                    <button (click)="hideFeatureDetails('standard')" class="close"></button>
                                    <button (click)="manualNext('standard')" class="next"></button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="price">
                        {{ plans.standard.price }}
                        <small>{{ plans.standard.priceUnit }}</small>
                    </div>
                    <a (click)="closeNotification()" class="cta">{{ plans.standard.ctaText }}</a>
                </div>
            </div>

            <!-- Advance Plan -->
            <div class="package advance">
                <div class="inner">
                    <div class="title">
                        {{ plans.advance.title }}
                        <span *ngIf="plans.advance.subtitle">{{ plans.advance.subtitle }}</span>
                    </div>

                    <div #advanceContent class="content">
                        <ul>
                            <li (click)="showFeatureDetail(feature.id, 'advance')"
                                *ngFor="let feature of features"
                                [class.active]="selectedFeatureId === feature.id && currentPlan === 'advance'"
                                [class.none]="!isFeatureIncluded(feature.id, 'advance')"
                                [class]="feature.id">
                                <span>{{ feature.title }}</span>
                                <i class="fa-solid fa-circle-info"></i>
                            </li>
                        </ul>

                        <!-- Swiper für Feature-Details - wird eingeblendet wenn ein Feature ausgewählt ist -->
                        <div *ngIf="showAdvanceFeatureDetails" class="feature-details-overlay">
                            <div class="feature-details-container">
                                <!-- Swiper -->
                                <div #advanceFactsSwiper class="swiper facts-swiper">
                                    <div class="swiper-wrapper">
                                        <div *ngFor="let feature of getIncludedFeatures('advance')" class="swiper-slide">
                                            <div class="feature-detail">
                                                <h3>{{ feature.title }}</h3>
                                                <p>{{ feature.description }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Buttons -->
                                <div class="buttons">
                                    <button (click)="manualPrev('advance')" class="prev"></button>
                                    <button (click)="hideFeatureDetails('advance')" class="close"></button>
                                    <button (click)="manualNext('advance')" class="next"></button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="price">
                        {{ plans.advance.price }}
                        <small>{{ plans.advance.priceUnit }}</small>
                    </div>
                    <a [href]="plans.advance.ctaLink" class="cta">{{ plans.advance.ctaText }}</a>
                </div>
            </div>
        </div>

        <div class="overlay-footer-nav">
            <button (click)="closeNotification()" class="close" type="button">
                <ng-container i18n="@@close">Schließen</ng-container>
            </button>
        </div>
    </div>
</div>
